import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';

export const PromotionOverviewQueryKeys = {
	all: ['promotion-overview'] as const,
	detail: (companyHotelId: number, filter: MarketStateFilterInput, includeBookingFunded: boolean) =>
		[...PromotionOverviewQueryKeys.all, companyHotelId, filter, includeBookingFunded] as const,
};
